<template>
  <div class="products">
    <layout>
      <md-app-content>
        <md-content>
          <md-progress-spinner v-if="!categories" :md-stroke="4" md-mode="indeterminate" class="products__spinner"></md-progress-spinner>

          <catalog v-if="categories" :categories="categories"></catalog>
        </md-content>
      </md-app-content>
    </layout>

    <catalog-item-create :categories="categories" v-if="showCreateItem"></catalog-item-create>
    <catalog-category-create v-if="showCreateCategory"></catalog-category-create>
    <catalog-item-edit v-if="editItem"></catalog-item-edit>
    <catalog-category-edit v-if="editCategory"></catalog-category-edit>

    <md-speed-dial class="md-bottom-right" md-direction="top" md-event="click">
      <md-speed-dial-target class="md-primary">
        <md-icon class="md-morph-initial">add</md-icon>
        <md-icon class="md-morph-final">close</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="md-icon-button" @click="showCreateItemForm(true)">
          <md-icon>local_bar</md-icon>
        </md-button>
        <md-button class="md-icon-button" @click="showCreateCategoryForm(true)">
          <md-icon>category
          </md-icon>
        </md-button>
      </md-speed-dial-content>
    </md-speed-dial>

    <snackbar></snackbar>

  </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters, mapActions} from 'vuex'
    import CatalogItemEdit from '../components/CatalogItemEdit'
    import CatalogCategoryEdit from '../components/CatalogCategoryEdit'
    import Catalog from '../components/Catalog'
    import CatalogItemCreate from '../components/CatalogItemCreate'
    import CatalogCategoryCreate from '../components/CatalogCategoryCreate'
    import Layout from '../components/Layout'
    import Snackbar from '../components/Snackbar'

    export default {
        name: 'products',
        components: {
            Catalog,
            CatalogItemCreate,
            CatalogCategoryCreate,
            CatalogItemEdit,
            CatalogCategoryEdit,
            Layout,
            Snackbar
        },
        data() {
            return {
                showSnackbar: true
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('catalog', [
                'categories',
                'editItem',
                'editCategory',
                'showCreateItem',
                'showCreateCategory'
            ]),
            showErrorMessage: function () {
                return this.error && this.showSnackbar
            }
        },
        methods: {
            ...mapActions('catalog', [
                'loadItems',
                'showCreateItemForm',
                'showCreateCategoryForm'
            ])
        },
        mounted() {
            this.loadItems(this.user.locationId)
        }
    }
</script>
